import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { UserService } from '../services/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private userService: UserService, private router: Router) { }

    checkLogin(): Observable<boolean> {
        return new Observable<boolean>(observable => {
            if (this.isLoggedIn()) {
                observable.next(true);
            } else {
                observable.next(false);
                this.router.navigateByUrl('/login');
            }
        });
    }

    private isLoggedIn(): boolean {
        if (this.userService.isActiveToken()) {
            const token = this.userService.getUserToken();
            const currentCenter = this.userService.getCenter().center;

            const user = this.userService.getUserToken();

            if (!token || !currentCenter || !user) {
              return false;
            }
            return true;
        }
        return false;
    }
}
